import { render, staticRenderFns } from "./111.vue?vue&type=template&id=252794da&scoped=true&"
var script = {}
import style0 from "./111.vue?vue&type=style&index=0&id=252794da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252794da",
  null
  
)

export default component.exports